import Const from 'constants';
import FetchWrapper from 'helpers/fetch-wrapper';
import {getModeSlatesFromSlatesPayload, getAllSlateIdsFromSlatesPayload} from 'helpers/slate';
import API from 'api';

let Slate = {
    getSlates(sport, site, gameType) {
        return (dispatch, getState) => {
            dispatch({
                type: Const.GET_SLATES_REQUEST,
            });

            const {sportConfig} = getState();
            const sport = sport || sportConfig.getSport();
            const site = site || sportConfig.getSite();
            const gameType = gameType || sportConfig.getGameType();

            const url = API.to('GET_SLATES', {sport, site, gameType});

            return FetchWrapper.fetchGet(url)
                .then((json) => {
                    const {slates} = json.data;

                    const modeSlates = getModeSlatesFromSlatesPayload(slates, sportConfig.getMode());

                    dispatch({
                        type: Const.GET_SLATES_SUCCESS,
                        data: modeSlates,
                    });

                    const slateIds = getAllSlateIdsFromSlatesPayload(slates);

                    dispatch(this.clearOutdatedFiltersInStorage(slateIds));

                    return Promise.resolve(json);
                })
                .catch((error) =>
                    dispatch({
                        type: Const.GET_SLATES_FAILURE,
                        data: error,
                        error: true,
                    }),
                );
        };
    },
    getSlate(slateId, sport) {
        return (dispatch, getState) => {
            dispatch({type: Const.GET_SLATE_REQUEST});

            return FetchWrapper.fetchGet(API.to('GET_SLATE', {slateId, sport}))
                .then((json) => {
                    const {games = [], players = [], slate = {}, teams = []} = json.data;

                    dispatch(this.applySlate(slate));
                    dispatch(this.applyTeams(teams));
                    dispatch(this.applyGames(games));
                    dispatch(this.applyPlayers(players));

                    const {
                        playersData: {games: existingGames},
                    } = getState();

                    dispatch(this.updatePlayersWhoseGameStatusChanged(existingGames.getAllInactive()));

                    dispatch({type: Const.GET_SLATE_SUCCESS});

                    return Promise.resolve(json);
                })
                .catch((error) =>
                    dispatch({
                        type: Const.GET_SLATE_FAILURE,
                        data: error,
                        error: true,
                    }),
                );
        };
    },
    applySlate(slate) {
        return (dispatch) => {
            dispatch({
                type: Const.UPDATE_SLATE,
                data: slate,
            });
            dispatch(this.updateMaxSalaryIfNeeded());
        };
    },
    unsetSlates() {
        return {
            type: Const.UNSET_SLATES,
        };
    },
    updateSlate() {
        return (dispatch, getState) => {
            const {sportConfig} = getState();

            if (!sportConfig.hasSlateId()) {
                return;
            }

            const slateId = sportConfig.getSlateId();
            const sport = sportConfig.getSport();

            return FetchWrapper.fetchGet(API.to('GET_SLATE', {slateId, sport}))
                .then((json) => {
                    const {games = [], players = [], slate = {}, teams = []} = json.data;

                    dispatch(this.applySlate(slate));
                    dispatch(this.applyTeams(teams));
                    dispatch(this.applyUpdatedGames(games));
                    dispatch(this.applyUpdatedPlayers(players));

                    const {
                        playersData: {games: existingGames},
                    } = getState();

                    dispatch(this.updatePlayersWhoseGameStatusChanged(existingGames.getAllInactive()));

                    return Promise.resolve(json);
                })
                .catch((error) =>
                    dispatch({
                        type: Const.GET_SLATES_FAILURE,
                        data: error,
                        error: true,
                    }),
                );
        };
    },
};

export default Slate;
